"use client";

import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
import Img1 from "~/assets/images/home/section2-img1.png?url";
import Img2 from "~/assets/images/home/section2-img2.png?url";
import Img3 from "~/assets/images/home/section2-img3.png?url";
import Img4 from "~/assets/images/home/section2-img4.png?url";
import CollapsibleHeroCollection from "~/common/components/CollapsibleHeroCollection";
import SectionWrapper from "~/common/components/SectionWrapper";

// NOTE: Placeholder government feature keys. Replace with domain-specific translations later.
const section2Data = [
  {
    id: "digital-services",
    iconAlt: "Digital Services Icon",
    iconBgClass: "blue",
    titleKey: /** @i18n */ "solutions.government.sectionChatbot.digitalServices.title",
    descriptionKey: /** @i18n */ "solutions.government.sectionChatbot.digitalServices.description",
    image: Img1,
  },
  {
    id: "citizen-support",
    iconAlt: "Citizen Support Icon",
    iconBgClass: "pink",
    titleKey: /** @i18n */ "solutions.government.sectionChatbot.citizenSupport.title",
    descriptionKey: /** @i18n */ "solutions.government.sectionChatbot.citizenSupport.description",
    image: Img2,
  },
  {
    id: "knowledge-base",
    iconAlt: "Knowledge Base Icon",
    iconBgClass: "blue",
    titleKey: /** @i18n */ "solutions.government.sectionChatbot.knowledgeBase.title",
    descriptionKey: /** @i18n */ "solutions.government.sectionChatbot.knowledgeBase.description",
    image: Img3,
  },
  {
    id: "workflow-automation",
    iconAlt: "Workflow Automation Icon",
    iconBgClass: "pink",
    titleKey: /** @i18n */ "solutions.government.sectionChatbot.workflowAutomation.title",
    descriptionKey: /** @i18n */ "solutions.government.sectionChatbot.workflowAutomation.description",
    image: Img4,
  },
];

import styles from "./SectionChatbot.module.scss";

export default function SectionChatbot({ locale }) {
  const { t } = useTranslation(locale);

  return (
    <SectionWrapper className={styles.section} background={"/ecommerce/sectionChatbot-hero.svg"}>
      <div className={clsx("card", styles.card)}>
        <CollapsibleHeroCollection items={section2Data} t={t} />
      </div>
    </SectionWrapper>
  );
}
